import styled from 'styled-components';
import { useState } from 'react';
import { useAlert } from "react-alert"
import Web3 from "web3";
import https from 'https';
const Wrapper = styled.div`
  padding-top: 120px;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: 1200px){
    width: 1170px;
  }
  @media (min-width: 992px) and (max-width: 1199px)
    width: 970px;
  }
  @media (min-width: 768px) and (max-width: 991px){
    width: 750px;
  }
`
const Header = styled.h3`
  font-size: 36px;
  text-align: center;
  img {
    margin-right: 10px;
  }
 
`
const EnterURL = styled.div`
  display: flex;
  max-width: 740px;
  margin: 50px auto;
  input {
    flex: 1;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px 0 0 4px;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    outline-style: none;
  }
  button {
    height: 34px;
    border: 1px solid #ccc;
    border-radius: 0 4px 4px 0;
    padding: 6px 12px;
    font-size: 14px;
    margin-left: -1px;
    cursor: pointer;
    display: flex;
    span {
      position: relative;
      top: 2px;
    }
  }
`

const Anno = styled.div`
    button {
    height: 34px;
    border: 1px solid #ccc;
    border-radius: 4px 0 0 4px;
    padding: 6px 12px;
    font-size: 14px;
    margin-left: -1px;
    cursor: pointer;
    display: flex;
    span {
      position: relative;
      top: 2px;
    }
  }
`

const Des = styled.div`
  max-width: 740px;
  margin: 50px auto;
  text-align: justify-all;
  h3 {
    font-size: 24px;
    margin-top: 50px;
    //margin-left: 150px ;
    margin-bottom: 10px;
  }
  p {
    margin: 0 0 10px;
    line-height: 1.42857143;
  }
  dl {
    margin: 15px 0 20px;
    p {
      //margin-left: 150px;
    }
    display: flex;
    img {
      position: relative;
      top: 42px;
      width: 36px;
      height: 36px;
      margin-right: 30px;
      margin-left: 30px;
    }
  }
`
// console.log(fetch)

function CheckUrl(str) {
  const RegUrl = new RegExp()
  RegUrl.compile("^[A-Za-z]+://[A-Za-z0-9-_]+\\.[A-Za-z0-9-_%&\?\/.=]+$")
  if (!RegUrl.test(str)) {
    return false
  }
  return true
}
const SEND_URL = 'https://5b3b10kt20.execute-api.us-east-2.amazonaws.com/prod/twitter'
function App() {
  const alert = useAlert();
  const [username, setUsername] = useState('')
  const [address, setAddress] = useState('')
  const [loading, setLoading] = useState(false)

  const submit = async () => {
    let name = username;
    const web3 = new Web3()
    if (!web3.utils.isAddress(address)) {
      alert.error('Invalid input Address or UserName')
      return
    }
    if (!username.startsWith('@')) {
      name = '@'+ username;
    }

    setLoading(true)

    fetch(`${SEND_URL}?username=${name}&address=${address}`)
      .then(res => 
        res.json()
      )
      .then(res => {
        console.log(res)
        if (res.status === 'success') {
          setUsername('')
          setAddress('')
          alert.success(res.comment)
        } else {
          alert.error(res.comment)
        }
        setLoading(false)
      })
      .catch(error => {
        console.error(error)
        alert.error('Network error')
        setLoading(false)
      })
    //   } else {
    //     alert.error('Invalid input URL')
    //   }
    // } else {
    //   alert.error('Invalid input URL')
    // }
  }
  return (
    <Wrapper>
      <Header>
        Never Let Go
      </Header>
      <EnterURL>
        <Anno >
        <button disabled={true}>@</button>
        </Anno>
        <input onChange={(event) => { setUsername(event.target.value) }} value={username} id="username" name="username" type="text" className="form-control" placeholder="Twitter ID"></input>&nbsp;
        <input onChange={(event) => { setAddress(event.target.value) }} value={address} id="address" name="address" type="text" className="form-control" placeholder="Wallet Address"></input>
        <button disabled={loading} onClick={submit}>
          {loading && <div className="loader"></div>}
          <span>Submit</span>
        </button>
      </EnterURL>


      <Des>
        <h3>Promise us you’ll survive the volatility in DeFi.</h3>
        <dl>
          <dd>
            <p>
              Let’s make a splash.
              &nbsp;<a href="https://twitter.com/divergencedefi/status/1724025989918028016" target="_about:blank">Retweet</a>
              ,&nbsp;and fill in your ID on X. Welcome onboard.
            </p>
          </dd>
        </dl>
      </Des>
    </Wrapper>
  );
}

export default App;
